import type { KeyboardEvent } from 'react';

export const toggleOnEnter = (disabled: boolean, toggle: () => void) => (event: KeyboardEvent) => {
  if (event.key !== 'Enter' || event.repeat || disabled) return;
  event.preventDefault();
  toggle();
};
